import Navigator from './Navigator';

export const {push, setNavigator: setMasterNavigator} = new Navigator();